'use strict';

module.exports = function(angular, app) {
	app.service('dashboardQueryService', [function() {

		// EXTRACT DASHBOARD QUERY
		// removes meta key, leaving only the part of the query that's usable by Druid
		function extractQuery(dashboardQuery) {
			let druidQuery = Object.assign({}, dashboardQuery);
			delete druidQuery.meta;
			return druidQuery;
		}

		// LIMIT QUERY TO SINGLE SPLIT
		// removes all splits from dashboard query except one
		function limitQuery(dashboardQuery, splitField) {
			let limitedQuery = Object.assign({}, dashboardQuery);
			if (dashboardQuery.splits.length > 0) {
				let newSplitsArray = [];
				for (let i = 0; i < dashboardQuery.splits.length; i++ ) {
					if (dashboardQuery.splits[i].field === splitField) {
						newSplitsArray.push(dashboardQuery.splits[i]);
						break;
					}
				}
				limitedQuery.splits = newSplitsArray;
			}
			return limitedQuery;
		}

		return {
			extractQuery: extractQuery,
			limitQuery: limitQuery
		};

	}]);
};
